export {default as hexbin} from "./src/hexbin";



//////////////////
// WEBPACK FOOTER
// ./~/d3-hexbin/index.js
// module id = 1529
// module chunks = 0